<script>
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxColumn } from 'devextreme-vue/data-grid';

    export default {
        components: {
            AdminGrid,
            DxColumn
        },
        data() {
            return {
                dataSource: httpService.getDxDataSource('devices-by-user/grid')
            };
        }
    };
</script>

<template>
    <div class="main-content-header">
        <h3>
            <i class="bi bi-person-badge"></i>
            Devices by Users
        </h3>
    </div>
    <div class="main-content-body">
        <AdminGrid :data-source="dataSource" storage-key="devices-users" :show-actions="false">
            <DxColumn data-field="companyName" caption="Company" />
            <DxColumn data-field="username" />
            <DxColumn data-field="installationID" />
            <DxColumn data-field="deviceAccountId" caption="Device Account" />
            <DxColumn data-field="device" />
            <DxColumn data-field="operatingSystem" caption="OS" />
            <DxColumn data-field="firstSeen" data-type="date" format="MM/dd/yyyy hh:mm a" />
            <DxColumn data-field="lastSeen" data-type="date" format="MM/dd/yyyy hh:mm a" />
        </AdminGrid>
    </div>
</template>
